<h3 class="ui primary header">
  Deactivate eWallet Account
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div class="info">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
      stroke="#202223"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <p>
    To deactivate all eWallet accounts, your eWallet balance must be zero. You
    need to withdraw all funds to deactivate your eWallet account.
  </p>
</div>
<div class="content">
  <div
    class="ui basic vertical segment"
    [ngClass]="{ loading: pending }"
    style="margin-top: 20px"
  >
    <div
      class="account"
      *ngFor="let account of modal.context.balances"
      [ngClass]="{ non_zero: account.balance > 0 || account.bookBalance > 0 }"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div>
          <h3 style="font-size: 16px; font-weight: 700; color: #505050;" appMargin marginB=4px>{{ account.currencyShortName }}</h3>
          <h4>
            <span style="font-size: 12px; font-weight: 700; color: #505050;">Balance: </span>
            <span style="font-size: 12px; font-weight: 400; color: #505050;">{{ account.currencyCode }}{{ account?.balance || 0 | number: "1.2-2" }}</span>
          </h4>
          <h4>
            <span style="font-size: 12px; font-weight: 700; color: #505050;">Book Balance: </span>
            <span style="font-size: 12px; font-weight: 400; color: #505050;">{{ account.currencyCode }}{{ account?.bookBalance || 0 | number: "1.2-2" }}</span>
          </h4>
        </div>
        <button
          *ngIf="account.balance > 0"
          class="ui primary button"
          (click)="closeAccount(account)"
          autofocus
        >
          Withdraw all funds
        </button>
      </div>
    </div>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
    <button
      class="ui primary button"
      (click)="deactivateWallet()"
      [ngClass]="{ loading: pending }"
      [disabled]="checkIfActive()"
      autofocus
    >
      Deactivate
    </button>
  </div>
</div>
